import t from "./ghl-ui.es814.js";
import o from "./ghl-ui.es731.js";
function i(n, r) {
  return n && t(r, o(r), n);
}
export {
  i as default
};
